import { connect } from 'react-redux';
import Cancellation from './cancellation';

export default connect()(Cancellation);
